<div class="container-fluid">
  <div class="row">
    <div class="col-xs-12">
      <div class="page-title text-center">
        <h2>{{ title }}</h2>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-left sidebar col-md-3 blog-side">
      <div class="sidebar-categories">
        <h4 class="sidebar-title">Blog Categories</h4>
        <ul class="category-list">
          <li [class.active]="!selectedCategorySlug">
            <a (click)="selectCategory(null, null)">
              <span class="category-name">All Categories</span>
            </a>
          </li>
          <li *ngFor="let cat of categories" [class.active]="selectedCategorySlug === cat.slug">
            <a (click)="selectCategory(cat.slug, cat.name)">
              <span class="category-name">{{ cat.name }}</span>
              <span class="category-count" *ngIf="cat.nbBlogs > 0">{{ cat.nbBlogs }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-md-9 main-blog">
      <div id="main" class="blog-wrapper">
        <div id="primary" class="site-content">
          <div id="content" role="main">

            <div class="blog-header" *ngIf="selectedCategoryName">
              <h3 class="blog-category-title">{{ selectedCategoryName }}</h3>
            </div>

            <p *ngIf="loading else blog" style="text-align: center; padding: 10px 0;">
              <label>{{'common.loading' | translate}} ...</label>
            </p>

            <ng-template #blog>
              <p *ngIf="user != null" class="blog_entry" style="text-align: right; margin-bottom: 20px;">
                <a [routerLink]="['/blog/add']" class="btn btn-success" id="btn-submit">{{'blog.add' | translate}}</a>
              </p>

              <p *ngIf="blogPosts.length === 0" class="text-center" style="padding: 40px 0; color: #888;">
                No blog posts found in this category.
              </p>

              <article *ngFor="let blog of blogPosts | paginate: config" class="blog-post-item" style="margin-bottom: 30px; overflow: hidden;">
                <div class="row">

                  <div class="col-xs-12 col-md-4">
                    <a [routerLink]="[blog.slug != null ? blog.slug : blog.title , blog.id]" class="blog-post-thumbnail">
                      <img [src]="getImageSrc(blog.imagePath) + '?func=cropfit&width=364&dpr=1.75&bg_colour=auto&trim=0&quality=100'"
                           class="img-responsive"
                           style="width: 100%; height: auto; border-radius: 4px; margin-bottom: 15px;"
                           [alt]="blog.title" />
                    </a>
                  </div>

                  <div class="col-xs-12 col-md-8">
                    <div class="blog-post-summary">
                      <h2 class="blog-post-title" style="margin-top: 0;">
                        <a class="blog-link" style="text-decoration: none; color: #333; font-weight: bold;" [routerLink]="[blog.slug != null ? blog.slug : blog.title , blog.id]">
                          {{ blog.title }}
                        </a>
                      </h2>

                      <div class="blog-post-excerpt" style="margin-bottom: 10px; color: #666;" [innerHTML]="trimHTMLTags(blog.body) | slice:0:150">
                        ...
                      </div>

                      <div class="blog-post-meta" style="font-size: 0.9em; color: #999;">
                        <span class="blog-post-meta-date" style="margin-right: 15px;">
                          <i class="fa fa-calendar"></i> {{ blog.postedAt }}
                        </span>
                        <span class="blog-post-meta-comments-count">
                          <i class="fa fa-comments"></i> {{ blog.commentsCount }}
                        </span>
                      </div>
                    </div>
                  </div>

                </div>
              </article>
            </ng-template>

          </div>
        </div>

        <div class="pager" *ngIf="config && config.totalOfPage > 1" style="text-align: center; margin-top: 20px;">
            <pagination-controls class="pages" maxSize="5" [previousLabel]="'common.previous' | translate" [nextLabel]="'common.next' | translate"
                                 autoHide="true" id="listing" (pageChange)="pageChange($event)">
            </pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>
